import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  TableHead,
  Table,
  Button,
  FormControl,
  TextField,
  IconButton,
  Select,
  MenuItem,
  Autocomplete,
  Checkbox,
  Popper,
  InputAdornment,
  FormHelperText,
  Divider,
  Stack,
  Chip,
  InputLabel,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { tableCellLab, tableRowLab, xBtn } from "../../style/LapPageStyle";
import CloseIcon from "@mui/icons-material/Close";
import {
  menuItemStyle,
  selectField,
  textfieldTextBlueBorderPharmacy,
} from "../../style/AppointmentStyle";
import SearchIcon from "@mui/icons-material/Search";
import { drTableRow } from "../../style/DrApotComponentStyle";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { addBtn, primaryBtnPharmacy } from "../../style/PharmacyStyle";
import {
  setSearchPatient,
  setPatientDetailsData,
  setLoading,
} from "../../redux/slices/pharmacySlice";
import { useDispatch, useSelector } from "react-redux";
import {
  orangeButton,
  primaryBtnTeal,
  textfieldTextPrep,
} from "../../style/PatientDetailsStyle";
import UseSearchPatient from "../../helper/UseSearchPatient";
import UsePatientDetail from "../../helper/UsePatientDetail";
import useDebounce from "../../hooks/UseDebounce";
import UseGetMedicineDetail from "../../helper/UseGetMedicineDetail";
import {
  getMedicineByName,
  getPriceByQuantity,
  getPriceByQuantityForReturn,
  getPharmacyDetails,
} from "../../connections/getApi";
import { useQuery } from "@tanstack/react-query";
import PharmacyInvoice from "../PrintCompoents/PharmacyInvoice";
import { useReactToPrint } from "react-to-print";
import { generateBill, pharmacyCreateBill } from "../../connections/postApi";
import { showToast } from "../../utils/toastUtil";
import UseGetAllMedicineList from "../../helper/UseGetAllMedicineList";
import UseFetchGetOrganizationDetails from "../../helper/UseFetchGetOrganizationDetails";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import calender_icon from "../../assets/calender_icon.svg";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import {
  autoFocusOffWithOutBorder,
  drTableGreen,
  drTableRowBlueBg,
} from "../../style/PatinetFormStyle";
import {
  expiryMedicineFormate,
  formattedDate,
  formattedDateWithoutBg,
  highLightUPcomingMonthsExpire,
  isExpiredDate,
  roundToNearestUnit,
} from "../../utils/constantFunctions";
import { Edit } from "@mui/icons-material";
import NewMedicines from "../ModalChildren/NewMedicines";
import CustomModal from "../CustomModal/CustomModal";
import EditMedicineBatchShort from "../ModalChildren/EditMedicineBatchShort";
// import EditMedicinesShortCut from "../ModalChildren/EditMedicinesShortCut";

const NewBill = ({ onSuccess }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredMedicines, setFilteredMedicines] = useState([]);
  const [openSearchDropDown, setOpenSearchDropDown] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [patientId, setPatientId] = useState(null);
  const [searchData, setSearchData] = useState({
    q: "",
    page: 1,
    perPage: 10,
  });
  const [formState, setFormState] = useState({
    id: "",
    full_name: "",
    mobile: "",
    email: "",
    dob: "",
    gender: "",
    payment_type: "",
  });
  const [medicines, setMedicines] = useState([
    {
      id: "",
      name: "",
      quantity: "",
      batchId: null,
      batch: "",
      batchArray: [],
      returned: false,
      stock: "",
      packing: "",
      unitMrp: null,
      mrp: null,
      discount: null,
      gst: null,
      amount: null,
    },
  ]);
  const [total, setTotal] = useState(0);
  const [billSummary, setBillSummary] = useState({
    taxableTotal: 0,
    totalGst: 0,
    discount: 0,
    netPayable: 0,
  });
  const [select, setSelect] = useState(null);
  const [selectedMedicine, setSelectedMedicine] = useState(null);
  const [showButton, setShowButton] = useState(true);
  const [printInvoiceData, setPrintInvoiceData] = useState({});
  const [errors, setErrors] = useState({});
  const [openMedicineList, setOpenMedicines] = useState(false);
  const [highlightedIndexMedicine, setHighlightedIndexMedicine] = useState(0);
  const [editMedicine, setEditMedicine] = useState(false);
  const [selectedMedicineForEdit, setSelectedMedicineForEdit] = useState(null);
  const [invoicePaymentsAttributes, setInvoicePaymentsAttributes] = useState([
    { amount: "", payment_mode: "Cash" }, // default row
  ]);
  const [specialDiscountPct, setSpecialDiscountPct] = useState("");
  const [specialDiscountINR, setSpecialDiscountINR] = useState("");
  const specialDiscountPctRef = useRef("");
  const paymentModes = [
    { label: "UPI", value: "UPI" },
    { label: "Cash", value: "Cash" },
    { label: "Card", value: "Card" },
    { label: "Cheque", value: "Cheque" },
  ];

  const getAvailablePaymentModes = (currentIndex) => {
    const selectedModes = invoicePaymentsAttributes
      .map((item, index) => (index !== currentIndex ? item.payment_mode : null))
      .filter(Boolean);

    return paymentModes.filter((mode) => !selectedModes.includes(mode.value));
  };

  const [generatedAt, setGeneratedAt] = useState(
    dayjs().format("YYYY-MM-DDTHH:mm"),
  );

  const dispatch = useDispatch();
  const { data: medicineList } = UseGetAllMedicineList();

  const { data: orgData } = UseFetchGetOrganizationDetails();
  const orgFeatures =
    orgData?.payload?.organization_features ||
    orgData?.organization_features ||
    [];
  const allowPastDatedBill = orgFeatures.find(
    (f) => f?.key === "allow_past_dated_bill" && f?.active === true,
  );
  const allowBatchStockZero = orgFeatures.find(
    (f) => f?.key === "allow_batch_stock_zero" && f?.active === true,
  );

  const { data: pharmacyDetails } = useQuery({
    queryKey: ["getPharmacyDetails"],
    queryFn: getPharmacyDetails,
    refetchOnWindowFocus: false,
  });
  const roundOff = pharmacyDetails?.payload?.round_off ?? null;

  useEffect(() => {
    // Simulating fetching all data on component mount and storing it in local storage or state.
    if (
      medicineList?.payload?.medicines &&
      medicineList?.payload?.medicines?.length > 0
    ) {
      localStorage.setItem(
        "allMedicines",
        JSON.stringify(medicineList?.payload?.medicines),
      );
    }
  }, [medicineList]);

  const handleSearch = (event) => {
    // console.log(event.target.value);
    const query = event.target.value.toLowerCase();
    setSearchTerm(query);

    const storedMedicines =
      JSON.parse(localStorage.getItem("allMedicines")) || [];

    // Filter medicines based on search query
    const filteredMedicineList = storedMedicines.filter((medicine) =>
      medicine[1].toLowerCase().startsWith(query),
    );

    // Limit the results to top 10 and sort
    let limitedResults = filteredMedicineList.slice(0, 10);
    // console.log(limitedResults);
    if (!query) {
      limitedResults = [];
      console.log(limitedResults);
      setHighlightedIndexMedicine(0);
    }
    setFilteredMedicines(limitedResults);
  };

  const handleChange = (index, field, value) => {
    const newMedicines = medicines.map((medicine, idx) =>
      idx === index ? { ...medicine, [field]: value } : medicine,
    );
    setMedicines(newMedicines);
  };

  // const updateNameAndId = (index, value) => {
  //     const newMedicines = [...medicines];
  //     newMedicines[index] = {
  //         ...newMedicines[index],
  //         id: value[0],
  //         name: value[1],
  //     };
  //     setMedicines(newMedicines);
  // };
  const updateNameAndId = (index, value) => {
    setMedicines((prevMedicines) =>
      prevMedicines.map((medicine, idx) =>
        idx === index
          ? {
              ...medicine,
              id: value[0],
              name: value[1],
              quantity: "",
              batchId: null,
              batch: "",
              batchArray: [],
              returned: false,
              stock: "",
              packing: "",
              unitMrp: null,
              mrp: null,
              discount: null,
              gst: null,
              amount: null,
            }
          : medicine,
      ),
    );
  };

  const handlePresence = async (index, value) => {
    const medicineNames = medicines
      ?.slice(0, medicines?.length > 1 ? medicines?.length - 1 : 0)
      .map((med) => med.name)
      .join(",");
    // encodeURIComponent(medicineNames)
    // console.log(medicineNames);
    try {
      const res = await getMedicineByName(
        encodeURIComponent(medicineNames),
        encodeURIComponent(value[1]),
      );

      //  console.log(res.payload?.presence);
      if (res?.payload?.presence) {
        const updatedMedicines = medicines?.map((medicine, i) =>
          i === index
            ? { ...medicine, id: "", name: "", description: "", remark: "" }
            : medicine,
        );

        // Update the state with the cleared fields
        setMedicines(updatedMedicines);

        console.log(updatedMedicines, "Updated medicines list");
        showToast("Medicine already present in the list", "ERROR");
      }
    } catch (error) {
      console.log(error);
    }
    // console.log(value, " call api to check ");
    setFilteredMedicines([]);
  };

  // const handleKeyDown = (e, index, field) => {
  //   if (e.key === "Enter" && field === "name") {
  //     e.preventDefault();

  //     if (!medicines[index]?.name) {
  //       setTimeout(() => document.getElementById(`submit`).focus(), 0);
  //       return;
  //     }

  //     const currentInput = medicines[index]?.name?.toLowerCase() || "";

  //     const topOption = filteredMedicines.find((medicine) =>
  //       (medicine[1] || "").toLowerCase().startsWith(currentInput)
  //     );

  //     if (topOption) {
  //       setTimeout(() => {
  //         updateNameAndId(index, topOption);
  //         handlePresence(index, topOption);
  //         setSelectedMedicine({ name: topOption[1], id: topOption[0] });
  //         document.getElementById(`quantity-${index}`).focus();
  //       }, 100); // Delay to ensure the input value is fully captured
  //     }
  //   } else if (e.key === "Enter" && field === "quantity") {
  //     setTimeout(() => document.getElementById(`return-${index}`).focus(), 0);
  //   } else if (e.key === "Enter" && field === "return") {
  //     handleAddRow();
  //     setTimeout(() => document.getElementById(`name-${index + 1}`).focus(), 0);
  //   }
  // };

  const handleKeyDown = (e, index, field) => {
    if (field === "name") {
      if (["ArrowDown", "ArrowUp"].includes(e.key)) {
        e.preventDefault();
        // Navigate options with arrow keys
        setHighlightedIndexMedicine((prevIndex) => {
          if (e.key === "ArrowDown") {
            return prevIndex < filteredMedicines?.length - 1
              ? prevIndex + 1
              : 0;
          } else {
            return prevIndex > 0
              ? prevIndex - 1
              : filteredMedicines?.length - 1;
          }
        });
      } else if (e.key === "Tab") {
        if (!medicines[index]?.name) {
          setTimeout(() => document.getElementById(`submit`).focus(), 0);
          return;
        }

        e.preventDefault();
        const topOption = filteredMedicines[highlightedIndexMedicine];

        if (topOption) {
          updateNameAndId(index, topOption);
          handlePresence(index, topOption);
          setHighlightedIndexMedicine(0);
          setTimeout(() => {
            document.getElementById(`quantity-${index}`).focus();
          }, 0);
        } else {
          setHighlightedIndexMedicine(0);
          setTimeout(
            () => document.getElementById(`quantity-${index}`).focus(),
            0,
          ); // Focus next field
        }
      } else if (e.key === "Enter") {
        if (!medicines[index]?.name) {
          setTimeout(() => document.getElementById(`submit`).focus(), 0);
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        const topOption = filteredMedicines[highlightedIndexMedicine];

        if (topOption) {
          // console.log(topOption, ' topOption); in side if ');
          // setTimeout(() => {
          //   setHighlightedIndexMedicine(0);
          //   updateNameAndId(index, topOption); // Ensure this is wrapped inside a function
          //   handlePresence(index, topOption); // Ensure this is wrapped inside a function
          //   setSelectedMedicine({ name: topOption[1], id: topOption[0] });
          //   // document.getElementById(`description-${index}`).focus(); // Focus next field
          // }, 100);

          setTimeout(() => {
            // setHighlightedIndexMedicine(0);
            updateNameAndId(index, topOption);
            handlePresence(index, topOption);
            setTimeout(() => {
              setHighlightedIndexMedicine(0);
              document.getElementById(`quantity-${index}`).focus();
            }, 0);
          }, 100);
        } else {
          // console.log(topOption, 'topOption); in side else');
          // setHighlightedIndexMedicine(0);
          setTimeout(() => {
            document.getElementById(`quantity-${index}`).focus();
          }, 0);
        }
      }
    } else if (e.key === "Enter" && field === "quantity") {
      setTimeout(() => document.getElementById(`return-${index}`).focus(), 0);
      // if (medicines?.length > index + 1) {
      //     setTimeout(
      //         () => document.getElementById(`name-${index + 1}`).focus(),
      //         100
      //     );
      // } else {
      //     handleAddRow();
      //     setTimeout(() => document.getElementById(`name-${index + 1}`).focus(), 200);
      // }
    } else if (e.key === "Tab" && field === "return") {
      if (medicines?.length > index + 1) {
        setTimeout(
          () => document.getElementById(`name-${index + 1}`).focus(),
          100,
        );
      } else {
        handleAddRow();
        setTimeout(
          () => document.getElementById(`name-${index + 1}`).focus(),
          200,
        );
      }
    } else if (e.key === "Enter" && field === "return") {
      if (medicines?.length > index + 1) {
        setTimeout(
          () => document.getElementById(`name-${index + 1}`).focus(),
          100,
        );
      } else {
        handleAddRow();
        setTimeout(
          () => document.getElementById(`name-${index + 1}`).focus(),
          200,
        );
      }
    }
  };

  const { data: patientDetailsQuery } = UsePatientDetail(patientId);
  const { data: searchResult } = UseSearchPatient(searchData);
  const { data: medicineDetail } = UseGetMedicineDetail(selectedMedicine?.id);

  const { patientData } = useSelector((state) => state.pharmacy);
  const { patientDetailsData } = useSelector((state) => state.pharmacy);
  const { isLoading } = useSelector((state) => state.pharmacy);

  const debouncedInputValue = useDebounce(inputValue, 1000);

  // search query for patient by name or id
  useEffect(() => {
    if (debouncedInputValue) {
      setSearchData((prev) => ({ ...prev, q: debouncedInputValue }));
    } else {
      dispatch(setSearchPatient([]));
    }
  }, [debouncedInputValue, dispatch]);

  //save existing patient on select search
  const selectedPatient = (id) => {
    setPatientId(id?.id);
  };

  // handle search input
  const handleInputChange = (event, newInputValue) => {
    setInputValue(newInputValue);
  };

  useEffect(() => {
    if (searchResult?.payload?.patients) {
      dispatch(setSearchPatient(searchResult?.payload?.patients));
    }
  }, [searchResult, dispatch, inputValue]);

  useEffect(() => {
    if (patientDetailsQuery?.payload) {
      dispatch(setPatientDetailsData(patientDetailsQuery?.payload));
      setFormState({
        id: patientDetailsQuery?.payload?.id,
        full_name: patientDetailsQuery?.payload?.full_name,
        mobile: patientDetailsQuery?.payload?.mobile,
        email: patientDetailsQuery?.payload?.email,
        dob: patientDetailsQuery?.payload?.dob,
        gender: patientDetailsQuery?.payload?.gender,
      });
    }
    setErrors({});
  }, [dispatch, patientId, patientDetailsQuery]);
  //  select patient code ends here

  //handle form change
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({ ...prev, [name]: undefined }));
  };

  // handle add row
  const handleAddRow = () => {
    setMedicines([
      ...medicines,
      {
        name: "",
        quantity: "",
        batch: "",
        returned: false,
        stock: "",
        packing: "",
        UnitMRP: null,
        MRP: null,
        GST: null,
        amount: null,
      },
    ]);
  };

  //packing and stock show after select medicine
  useEffect(() => {
    if (medicineDetail && select !== null) {
      setMedicines((prevMedicines) =>
        prevMedicines?.map((medicine, idx) =>
          idx === select
            ? {
                ...medicine,
                stock: medicineDetail?.payload?.stock_left,
                packing: medicineDetail?.payload?.packing,
              }
            : medicine,
        ),
      );
      // console.log(packing, stock_left, '<-stock and packing');
    }
  }, [medicineDetail, select]);

  const handleQuantityChange = (index, field, value) => {
    if (value) {
      setMedicines((prevMedicines) =>
        prevMedicines.map((medicine, idx) =>
          idx === index
            ? {
                ...medicine,
                packing: "",
                unitMrp: null,
                mrp: null,
                discount: null,
                gst: null,
                amount: null,
              }
            : medicine,
        ),
      );
    }

    const newMedicines = medicines?.map((medicine, idx) =>
      idx === index ? { ...medicine, [field]: value } : medicine,
    );

    setMedicines(newMedicines);

    // Clearing the quantity (or picking a batch before typing one) is not an
    // error. The backend answers 204 No Content for a blank quantity, which
    // comes back as null and would be reported below as "batch out of stock".
    // Drop the row's error state and skip the request instead.
    const quantityToPrice =
      field === "batchId" ? medicines[index]?.quantity : value;
    if (!quantityToPrice || Number(quantityToPrice) <= 0) {
      // a request for the old quantity may still be in flight — drop it, or it
      // would land and price a row the user has just cleared
      if (priceRequestControllers.current.has(index)) {
        priceRequestControllers.current.get(index).abort();
      }
      setMedicines((prev) =>
        prev.map((medicine, idx) =>
          idx === index ? { ...medicine, batchError: false } : medicine,
        ),
      );
      return;
    }

    if (medicines[index]?.id) {
      // Cancel any in-flight request for this row
      if (priceRequestControllers.current.has(index)) {
        priceRequestControllers.current.get(index).abort();
        priceRequestControllers.current.delete(index);
        pendingPriceCount.current -= 1;
        if (pendingPriceCount.current < 0) pendingPriceCount.current = 0;
      }

      const controller = new AbortController();
      priceRequestControllers.current.set(index, controller);
      pendingPriceCount.current += 1;
      setIsPriceFetching(true);

      getPriceByQuantity(
        medicines[index].id,
        field === "batchId" ? medicines[index].quantity : value,
        field === "batchId" ? value : medicines[index].batchId,
        undefined,
        controller.signal,
      )
        .then((res) => {
          // Error response (e.g. selected batch is out of stock) or malformed body
          if (res?.__httpError || !res?.payload?.batches) {
            console.log("get_price_by_quantity error body:", res);
            showToast(
              res?.payload?.message ||
                res?.status?.message ||
                res?.message ||
                res?.error ||
                res?.errors?.[0] ||
                "Selected batch is out of stock or unavailable.",
              "ERROR",
            );
            // Flag this row so the batch cell shows a red border
            setMedicines((prev) =>
              prev.map((medicine, idx) =>
                idx === index ? { ...medicine, batchError: true, } : medicine,
              ),
            );
            return;
          }

          const {
            selected_batch,
            discount,
            mrp,
            batches,
            unit_price,
            grand_total,
            stock_left,
            is_consumable,
          } = res.payload;

          const matchedBatch = batches?.find(
            (b) => b.id === selected_batch?.id,
          );

          // Update the medicine entry with the new price data
          const updatedMedicines = newMedicines.map((medicine, idx) =>
            idx === index
              ? {
                  ...medicine,
                  batchId: selected_batch?.id,
                  batch: matchedBatch || selected_batch,
                  batchArray: batches,
                  stock: stock_left,
                  packing: matchedBatch?.packing || batches[0]?.packing,
                  unitMrp: medicine.returned ? -unit_price : unit_price,
                  mrp: medicine.returned ? -mrp : mrp,
                  discount: medicine.returned
                    ? `-${discount}%`
                    : `${discount}%`,
                  gst: matchedBatch?.gst ?? 0,
                  amount: medicine.returned ? -grand_total : grand_total,
                  is_consumable,
                  batchError: false,
                }
              : medicine,
          );
          setMedicines(updatedMedicines);
          dispatch(setLoading(false));
        })
        .catch((error) => {
          if (error?.name === "AbortError") return; // cancelled — ignore
          console.log("Error fetching price:", error);
          showToast(
            error?.status?.message || "Something went wrong fetching price.",
            "ERROR",
          );
          // Flag this row so the batch cell shows a red border
          setMedicines((prev) =>
            prev.map((medicine, idx) =>
              idx === index ? { ...medicine, batchError: true } : medicine,
            ),
          );
        })
        .finally(() => {
          priceRequestControllers.current.delete(index);
          pendingPriceCount.current -= 1;
          if (pendingPriceCount.current <= 0) {
            pendingPriceCount.current = 0;
            setIsPriceFetching(false);
          }
        });
    }
  };

  const handleReturnChange = (index) => {
    const newMedicines = medicines.map((medicine, idx) =>
      idx === index ? { ...medicine, returned: !medicine.returned } : medicine,
    );
    setMedicines(newMedicines);
    if (priceRequestControllers.current.has(index)) {
      priceRequestControllers.current.get(index).abort();
      priceRequestControllers.current.delete(index);
      pendingPriceCount.current -= 1;
      if (pendingPriceCount.current < 0) pendingPriceCount.current = 0;
    }

    const controller = new AbortController();
    priceRequestControllers.current.set(index, controller);
    pendingPriceCount.current += 1;
    setIsPriceFetching(true);
    getPriceByQuantityForReturn(medicines[index].id, medicines[index].quantity)
      .then((res) => {
        // console.log(res.payload);
        const {
          selected_batch,
          discount,
          mrp,
          batches,
          unit_price,
          grand_total,
        } = res.payload;

        const matchedBatch = batches?.find((b) => b.id === selected_batch?.id);

        // Update the medicine entry with the new price data
        const updatedMedicines = newMedicines.map((medicine, idx) =>
          idx === index
            ? {
                ...medicine,
                batchId: selected_batch?.id,
                batch: matchedBatch || selected_batch,
                batchArray: batches,
                packing: matchedBatch?.packing || batches[0]?.packing,
                unitMrp: medicine.returned ? -unit_price : unit_price,
                mrp: medicine.returned ? -mrp : mrp,
                discount: medicine.returned ? `-${discount}%` : `${discount}%`,
                gst: matchedBatch?.gst ?? 0,
                amount: medicine.returned ? -grand_total : grand_total,
              }
            : medicine,
        );

        setMedicines(updatedMedicines);
      })
      .catch((error) => {
        if (error?.name === "AbortError") return; // cancelled — ignore
        console.error("Error fetching price:", error);
      })
      .finally(() => {
        priceRequestControllers.current.delete(index);
        pendingPriceCount.current -= 1;
        if (pendingPriceCount.current <= 0) {
          pendingPriceCount.current = 0;
          setIsPriceFetching(false);
        }
      });
  };

  useEffect(() => {
    const spDiscPct = parseFloat(specialDiscountPct) || 0;
    let totalAmount = 0;
    let discountTotal = 0;
    let validMedicines = 0;
    let hasInvalidQuantity = false;
    let gstTotal = 0;

    medicines.forEach((medicine) => {
      if (
        medicine.name &&
        medicine.quantity &&
        medicine.quantity > 0 &&
        medicine?.id
      ) {
        validMedicines++;
        const rawAmt =
          (parseFloat(medicine.unitMrp) || 0) *
          (parseFloat(medicine.quantity) || 0);
        const effectiveAmount =
          spDiscPct > 0
            ? rawAmt * (1 - spDiscPct / 100)
            : parseFloat(medicine.amount) || 0;
        const gstPct = parseFloat(medicine.gst) || 0;
        const gstAmount = (effectiveAmount * gstPct) / (100 + gstPct);

        totalAmount += effectiveAmount;
        gstTotal += gstAmount;

        if (effectiveAmount > 0) {
          discountTotal +=
            spDiscPct > 0
              ? rawAmt * (spDiscPct / 100)
              : rawAmt * ((parseFloat(medicine.discount) || 0) / 100);
        }
      }

      if (medicine.name && (!medicine.quantity || medicine.quantity <= 0)) {
        hasInvalidQuantity = true;
      }
    });

    const taxableTotal = totalAmount - gstTotal;
    const netPayable = roundToNearestUnit(totalAmount, roundOff);
    setSelect(validMedicines);
    setTotal(netPayable);
    setBillSummary({
      taxableTotal,
      totalGst: gstTotal,
      discount: discountTotal,
      netPayable,
    });

    setShowButton(!hasInvalidQuantity && validMedicines > 0);
  }, [medicines, roundOff, specialDiscountPct]);

  // Keep ref in sync so the effect below can read latest % without depending on it
  specialDiscountPctRef.current = specialDiscountPct;

  // Re-sync ₹ field when batch/quantity changes update unit prices (not when user types %)
  useEffect(() => {
    const pct = parseFloat(specialDiscountPctRef.current);
    if (!specialDiscountPctRef.current || isNaN(pct) || pct <= 0) return;
    const raw = medicines.reduce((sum, m) => {
      if (m.name && m.quantity > 0 && m.id)
        return (
          sum + (parseFloat(m.unitMrp) || 0) * (parseFloat(m.quantity) || 0)
        );
      return sum;
    }, 0);
    setSpecialDiscountINR(((raw * pct) / 100).toFixed(2));
  }, [medicines]);

  const printRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "medicine invoice Print",
    onAfterPrint: () => console.log("Print job finished"),
  });

  const handleRemoveRow = (index) => {
    const newMedicines = medicines.filter((_, idx) => idx !== index);
    setMedicines(newMedicines);
  };

  const updatePaymentRow = (index, key, value) => {
    setInvoicePaymentsAttributes((prev) =>
      prev.map((row, i) => (i === index ? { ...row, [key]: value } : row)),
    );
  };

  const toNum = (v) => {
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : 0;
  };

  // 1) Default: keep row-0 amount synced with netPayable (only when NOT already split)
  useEffect(() => {
    setInvoicePaymentsAttributes((prev) => {
      const absT = Math.abs(Number(billSummary.netPayable || 0));

      // if already split (2 rows), keep remaining updated
      if (prev.length === 2) {
        const a1 = toNum(prev[0]?.amount);
        const remaining = Math.max(absT - a1, 0);
        return [
          { ...prev[0], amount: prev[0]?.amount ?? "" },
          { ...prev[1], amount: remaining.toFixed(2) },
        ];
      }

      // single row: always show abs netPayable
      const row0 = prev[0] || { payment_mode: "Cash", amount: "" };
      return [{ ...row0, amount: absT.toFixed(2) }];
    });
  }, [billSummary.netPayable]);

  // 2) When user edits first amount -> auto create/update/remove second row
  const handlePrimaryAmountChange = (value) => {
    setInvoicePaymentsAttributes((prev) => {
      const absT = Math.abs(Number(billSummary.netPayable || 0));
      const a1 = toNum(value);

      // If empty or zero, keep single row (collapse finalised on blur)
      if (value === "" || a1 === 0) {
        return [{ ...prev[0], amount: value }];
      }

      // If user enters >= abs total => keep single row only
      if (a1 >= absT) {
        return [{ ...prev[0], amount: value }];
      }

      // If user enters less than abs total => create/update second row for remaining
      const remaining = (absT - a1).toFixed(2);
      const row0 = { ...prev[0], amount: value };

      // if row2 exists update it else create it
      if (prev.length === 2) {
        return [row0, { ...prev[1], amount: remaining }];
      }

      return [
        row0,
        {
          amount: remaining,
          payment_mode: getAvailablePaymentModes(1)[0]?.value,
        }, // default second mode
      ];
    });
  };

  // 3) On blur: if primary is 0 or empty, collapse to single row
  const handlePrimaryAmountBlur = () => {
    setInvoicePaymentsAttributes((prev) => {
      const a1 = toNum(prev[0]?.amount);
      if (a1 === 0 || prev[0]?.amount === "") {
        const absT = Math.abs(Number(total || 0));
        return [{ ...prev[0], amount: absT.toFixed(2) }];
      }
      return prev;
    });
  };

  //   const paidTotal = invoicePaymentsAttributes.reduce(
  //   (sum, row) => sum + toNum(row?.amount),
  //   0,
  // );

  // const remainingTotal = (Number(total || 0) - paidTotal).toFixed(2);

  const validateForm = () => {
    let formValid = true;
    const newErrors = {};

    if (!formState.full_name) {
      newErrors.full_name = "Full Name cannot be blank";
      formValid = false;
    }

    // Mobile number validation (10 digits)
    if (!formState?.mobile) {
      newErrors.mobile = "Mobile cannot be blank";
      formValid = false;
    } else if (!/^\d{10}$/.test(formState.mobile)) {
      newErrors.mobile = "Please enter a valid 10-digit mobile number";
      formValid = false;
    }

    if (!formState?.dob) {
      newErrors.dob = "Date of Birth cannot be blank";
      formValid = false;
    }
    if (!formState?.gender) {
      newErrors.gender = "Gender cannot be blank";
      formValid = false;
    }

    if (
      allowPastDatedBill &&
      generatedAt &&
      dayjs(generatedAt).isAfter(dayjs())
    ) {
      newErrors.generatedAt = "Generated At cannot be a future date";
      formValid = false;
    }

    // ✅ PAYMENT VALIDATION (Smart split)
    const absTotal = Math.abs(Number(billSummary.netPayable || 0));
    const t = absTotal.toFixed(2);
    const rows = invoicePaymentsAttributes;

    if (!rows?.[0]?.payment_mode) {
      newErrors.split_payment = "Please select payment mode";
      formValid = false;
    } else {
      // row0 amount should exist
      const a1 = toNum(rows?.[0]?.amount);
      if (a1 <= 0 && absTotal > 0) {
        newErrors.split_payment = "Please enter valid amount";
        formValid = false;
      }

      if (rows.length === 2) {
        const a2 = toNum(rows?.[1]?.amount);

        if (!rows?.[1]?.payment_mode) {
          newErrors.split_payment =
            "Please select payment mode for 2nd payment";
          formValid = false;
        } else {
          const sum = (a1 + a2).toFixed(2);
          if (sum !== t) {
            newErrors.split_payment = `Payment total must equal invoice total (${t})`;
            formValid = false;
          }
        }
      } else {
        // single row must match total
        const sum = a1.toFixed(2);
        if (sum !== t) {
          newErrors.split_payment = `Amount must equal total (${t})`;
          formValid = false;
        }
      }
    }

    setErrors(newErrors);
    return formValid;
  };

  const [isButtonDisable, setIsButtonDisable] = useState(false);
  const [isPriceFetching, setIsPriceFetching] = useState(false);
  const [showPastBillConfirm, setShowPastBillConfirm] = useState(false);
  const priceRequestControllers = useRef(new Map()); // index -> AbortController
  const pendingPriceCount = useRef(0);
  //handle save & print invoice
  const getRawTotal = () =>
    medicines.reduce((sum, m) => {
      if (m.name && m.quantity > 0 && m.id)
        return (
          sum + (parseFloat(m.unitMrp) || 0) * (parseFloat(m.quantity) || 0)
        );
      return sum;
    }, 0);

  const handleSpecialDiscountPct = (val) => {
    setSpecialDiscountPct(val);
    const pct = parseFloat(val);
    if (!val || isNaN(pct)) {
      setSpecialDiscountINR("");
      return;
    }
    setSpecialDiscountINR(((getRawTotal() * pct) / 100).toFixed(2));
  };

  const handleSpecialDiscountINR = (val) => {
    setSpecialDiscountINR(val);
    const inr = parseFloat(val);
    const raw = getRawTotal();
    if (!val || isNaN(inr) || raw === 0) {
      setSpecialDiscountPct("");
      return;
    }
    setSpecialDiscountPct(((inr / raw) * 100).toFixed(2));
  };

  const saveAndPrint = async (skipPastCheck = false) => {
    if (isPriceFetching) {
      showToast("Price update in progress, please wait.", "WARNING");
      return;
    }
    if (!validateForm()) {
      setIsButtonDisable(false);
      return;
    }
    if (
      !skipPastCheck &&
      allowPastDatedBill &&
      dayjs(generatedAt).isBefore(dayjs(), "day")
    ) {
      setShowPastBillConfirm(true);
      return;
    }
    setIsButtonDisable(true);

    const invalidMedicines = medicines.filter(
      (medicine) =>
        medicine?.id && !medicine?.batchId && medicine?.is_consumable === false,
    );

    if (invalidMedicines.length > 0) {
      const names = invalidMedicines.map((m) => `[${m.name}]`).join(", ");
      showToast(
        `Batch not selected for ${names}. Please either select a batch or remove the medicine.`,
        "ERROR",
      );
      setIsButtonDisable(false);
      return;
    }

    const validMedicines = medicines?.filter(
      (medicine) =>
        medicine?.id && medicine?.quantity && medicine?.quantity > 0,
    );

    if (validMedicines?.length === 0) {
      showToast(
        "At least one medicine is required to generate the invoice.",
        "ERROR",
      );
      setIsButtonDisable(false);
      return;
    }

    // ✅ DUPLICATE MEDICINE VALIDATION
    const medicineIds = validMedicines.map((m) => m.id);
    const duplicateMedicines = validMedicines.filter(
      (item, index) => medicineIds.indexOf(item.id) !== index,
    );

    if (duplicateMedicines.length > 0) {
      const duplicateNames = [
        ...new Set(duplicateMedicines.map((m) => `[${m.name}]`)),
      ].join(", ");
      showToast(
        `Duplicate medicine found for ${duplicateNames}. Please combine quantities into a single row or remove duplicates.`,
        "ERROR",
      );
      setIsButtonDisable(false);
      return;
    }

    // ✅ Stock Validation Check
    const insufficientStock = validMedicines?.filter((med) => {
      // Only check for items that are NOT returned
      if (!med?.returned) {
        const batchStock = med?.stock || 0;
        const requiredQty = med?.quantity || 0;
        return requiredQty > batchStock;
      }
      return false;
    });

    if (insufficientStock.length > 0) {
      const errorMsg = insufficientStock
        .map(
          (med) =>
            `[${med?.name}] Batches , Available stocks: ${
              med?.stock || 0
            }, Required: ${med?.quantity})`,
        )
        .join(", ");
      showToast(`Insufficient stock for ${errorMsg}`, "ERROR");
      setIsButtonDisable(false);
      return;
    }

    const spDiscPct = parseFloat(specialDiscountPct) || 0;

    const formattedMedicines = validMedicines?.map((medicine) => {
      const rawAmt =
        (parseFloat(medicine?.unitMrp) || 0) *
        (parseFloat(medicine?.quantity) || 0);
      const effectivePct =
        spDiscPct > 0 ? spDiscPct : parseFloat(medicine?.discount) || 0;
      const effectiveAmount =
        spDiscPct > 0 ? rawAmt * (1 - spDiscPct / 100) : medicine?.amount || 0;
      const discountValue = rawAmt * (effectivePct / 100);
      const discountPerUnit =
        (parseFloat(medicine?.unitMrp) || 0) * (effectivePct / 100);
      return {
        id: medicine?.id,
        name: medicine.name,
        batch: medicine?.batch?.id,
        packing: medicine?.packing,
        quantity: medicine?.quantity,
        cost_per_unit: medicine?.unitMrp,
        cost: rawAmt.toFixed(2),
        amount: effectiveAmount.toFixed(2),
        discount_per_unit: discountPerUnit.toFixed(2),
        discount: discountValue.toFixed(2),
        ...(spDiscPct > 0 ? { special_discount: spDiscPct } : {}),
        returned: medicine?.returned,
      };
    });

    const total = validMedicines.reduce((sum, medicine) => {
      return (
        sum +
        (parseFloat(medicine?.unitMrp) || 0) *
          (parseFloat(medicine?.quantity) || 0)
      );
    }, 0);

    const netTotal = validMedicines.reduce((sum, medicine) => {
      const rawAmt =
        (parseFloat(medicine?.unitMrp) || 0) *
        (parseFloat(medicine?.quantity) || 0);
      return (
        sum +
        (spDiscPct > 0 ? rawAmt * (1 - spDiscPct / 100) : medicine?.amount || 0)
      );
    }, 0);

    const totalGst = validMedicines.reduce((sum, medicine) => {
      const rawAmt =
        (parseFloat(medicine?.unitMrp) || 0) *
        (parseFloat(medicine?.quantity) || 0);
      const effectiveAmount =
        spDiscPct > 0 ? rawAmt * (1 - spDiscPct / 100) : medicine?.amount || 0;
      const gstPct = parseFloat(medicine?.gst) || 0;
      return sum + (effectiveAmount * gstPct) / (100 + gstPct);
    }, 0);

    const taxableTotal = netTotal - totalGst;
    const cgst = totalGst / 2;
    const sgst = totalGst / 2;
    const grandTotal = roundToNearestUnit(netTotal, roundOff);

    const discount = validMedicines.reduce((sum, medicine) => {
      const rawAmt =
        (parseFloat(medicine.unitMrp) || 0) *
        (parseFloat(medicine.quantity) || 0);
      const effectivePct =
        spDiscPct > 0 ? spDiscPct : parseFloat(medicine.discount) || 0;
      return sum + rawAmt * (effectivePct / 100);
    }, 0);

    console.log("Bill Summary:", {
      total: total.toFixed(2),
      taxable_total: taxableTotal.toFixed(2),
      total_gst: totalGst.toFixed(2),
      cgst: cgst.toFixed(2),
      sgst: sgst.toFixed(2),
      grand_total: grandTotal.toFixed(2),
      discount: spDiscPct > 0 ? spDiscPct : discount.toFixed(2),
    });

    const invoice_payments_attributes = invoicePaymentsAttributes
      .slice(0, 2) // only allow max 2
      .map((p) => ({
        amount: Number(toNum(p.amount).toFixed(2)),
        payment_mode: p.payment_mode,
      }));

    if (patientDetailsData?.id) {
      const payload = {
        patient: {
          full_name: formState?.full_name,
          dob: formState?.dob,
          gender: formState?.gender,
          mobile: formState?.mobile,
          email: formState?.email,
          // patient_id: patientDetailsData?.id,
        },
        is_return: false,
        medicines: formattedMedicines,
        discount: discount.toFixed(2),
        ...(spDiscPct > 0 ? { special_discount: spDiscPct } : {}),
        total: total.toFixed(2),
        taxable_total: taxableTotal.toFixed(2),
        cgst: cgst.toFixed(2),
        sgst: sgst.toFixed(2),
        grand_total: grandTotal.toFixed(2),
        config_round_off: roundOff,
        // prescription_id: patientDetailsData?.appointments?.prescription_id || null,
        // invoice_id: patientDetailsData?.invoice_id || null,
        patient_id: formState?.id || null,
        invoice_payments_attributes,
        ...(allowPastDatedBill &&
          dayjs(generatedAt).isBefore(dayjs(), "day") && {
            generated_at: dayjs(generatedAt).format("YYYY-MM-DD h:mm A"),
          }),
      };
      const res = await pharmacyCreateBill(payload);
      setPrintInvoiceData(res);
      console.log(res);

      if (res?.status?.status === "SUCCESS") {
        setTimeout(() => {
          showToast("Generating Invoice Print ", "SUCCESS");
          handlePrint();
          onSuccess();
        }, 0);
        //  close modal
      } else {
        showToast(
          res?.status?.message || res?.status?.status,
          res?.status?.status,
        );
      }
    } else {
      const payload = {
        patient: {
          full_name: formState?.full_name,
          dob: formState?.dob,
          gender: formState?.gender,
          mobile: formState?.mobile,
          email: formState?.email,
        },
        is_return: false,
        discount: discount.toFixed(2),
        ...(spDiscPct > 0 ? { special_discount: spDiscPct } : {}),
        total: total.toFixed(2),
        taxable_total: taxableTotal.toFixed(2),
        cgst: cgst.toFixed(2),
        sgst: sgst.toFixed(2),
        grand_total: grandTotal.toFixed(2),
        config_round_off: roundOff,
        medicines: formattedMedicines,
        invoice_payments_attributes,
        ...(allowPastDatedBill &&
          dayjs(generatedAt).isBefore(dayjs(), "day") && {
            generated_at: dayjs(generatedAt).format("YYYY-MM-DD h:mm A"),
          }),
      };

      const res = await pharmacyCreateBill(payload);
      setPrintInvoiceData(res);
      console.log(res);
      if (res?.status?.status === "SUCCESS") {
        setTimeout(() => {
          showToast("generating invoice print ", "SUCCESS");
          handlePrint();
          onSuccess();
        }, 0);
      }
      showToast(res?.status?.message, res?.status?.status);
    }
    setIsButtonDisable(false);
  };

  // console.log(medicines);
  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          height: "90vh",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            overflowY: "auto",
            maxHeight: "80vh",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            "-ms-overflow-style": "none",
            "scrollbar-width": "none",
          }}
        >
          {/* <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        position="sticky"
                    >
                        <Box></Box>


                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                            <ReceiptLongIcon sx={{ color: 'neutral.navyBlue', marginBottom: "4px", marginRight: '8px' }} />
                            <Typography
                                variant="heading_Large"
                                fontWeight={700}
                                gutterBottom
                                sx={headingStyle}
                            >
                                New  Bill
                            </Typography>
                        </Box>
                        <IconButton sx={{ marginBottom: "2rem" }} onClick={onClose}>
                            <CloseIcon size="small" sx={{ color: "red" }} />
                        </IconButton>
                    </Box> */}

          <Grid container spacing={2}>
            {/* {"-----Search Patient Information-----"} */}
            <Grid item sm={5}>
              <Autocomplete
                freeSolo
                popupIcon={false}
                open={openSearchDropDown}
                // inputValue={inputValue}
                sx={textfieldTextPrep}
                onOpen={() => setOpenSearchDropDown(true)}
                onClose={() => {
                  dispatch(setSearchPatient([]));
                  setOpenSearchDropDown(false);
                }}
                onChange={(event, newValue) => {
                  if (newValue) {
                    selectedPatient(newValue);
                    setInputValue("");
                  }
                }}
                onInputChange={(event, newInputValue) => {
                  if (newInputValue === "" && formState?.id) {
                    // Reset form state when input is cleared
                    setFormState({
                      id: "",
                      full_name: "",
                      mobile: "",
                      email: "",
                      dob: "",
                      gender: "",
                    });
                  }
                  setInputValue(newInputValue);
                  handleInputChange(event, newInputValue);
                }}
                options={patientData || []}
                filterOptions={(options) => options}
                getOptionLabel={(option) =>
                  option.uid && option.full_name
                    ? `${option.uid} - ${option.full_name}`
                    : ""
                }
                renderOption={(props, option) => (
                  <MenuItem
                    key={option.id + Math.random()}
                    // onClick={() => selectedPatient(option)}
                    {...props}
                    sx={{
                      ...menuItemStyle,
                    }}
                  >
                    {" "}
                    {option.uid
                      ? `${option.uid} - ${option.full_name}`
                      : option.full_name}
                  </MenuItem>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    name="full_name"
                    onChange={handleFormChange}
                    required
                    id="search"
                    placeholder="Search Patient"
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          <SearchIcon
                            sx={{ opacity: 0.4, marginRight: 3 }}
                            color="grey"
                          />
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                    error={!!errors.full_name}
                    helperText={errors.full_name}
                  />
                )}
              />
            </Grid>

            <Grid item sm={2}>
              <TextField
                fullWidth
                onChange={handleFormChange}
                value={formState.email}
                name="email"
                placeholder="Email"
                variant="outlined"
                sx={textfieldTextPrep}
                error={!!errors.email}
                helperText={errors.email}
                type="email"
              />
            </Grid>

            <Grid item sm={2}>
              <TextField
                fullWidth
                onChange={handleFormChange}
                value={formState.mobile}
                name="mobile"
                placeholder="Mobile"
                // type="mobile"
                required
                variant="outlined"
                inputProps={{
                  maxLength: 10,
                  inputMode: "numeric",
                  pattern: "[0-9]*", // Ensure only numeric values are accepted
                }}
                sx={textfieldTextPrep}
                error={!!errors.mobile}
                helperText={errors.mobile}
              />
            </Grid>

            <Grid item sm={2}>
              <FormControl variant="outlined" sx={{ width: "100%" }}>
                <TextField
                  fullWidth
                  required
                  onChange={handleFormChange}
                  value={formState.dob}
                  type="date"
                  name="dob"
                  sx={textfieldTextPrep}
                  InputLabelProps={{ shrink: true }}
                  placeholder="DOB"
                  error={!!errors.dob}
                  helperText={errors.dob}
                  inputProps={{ max: new Date().toISOString().split("T")[0] }}
                />
              </FormControl>
            </Grid>

            {allowPastDatedBill && (
              <Grid item sm={2}>
                <TextField
                  fullWidth
                  type="datetime-local"
                  label="Generated At"
                  value={generatedAt}
                  onChange={(e) => setGeneratedAt(e.target.value)}
                  sx={textfieldTextPrep}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ max: dayjs().format("YYYY-MM-DDTHH:mm") }}
                  error={!!errors.generatedAt}
                  helperText={errors.generatedAt}
                />
              </Grid>
            )}

            <Grid item sm={1}>
              <FormControl fullWidth variant="outlined">
                <Select
                  error={!!errors.gender}
                  required
                  fullWidth
                  sx={selectField}
                  value={formState?.gender}
                  onChange={handleFormChange}
                  name="gender"
                  displayEmpty
                  renderValue={(selected) => {
                    if (!selected) {
                      return (
                        <span style={{ color: "neutral.black" }}>Gender</span>
                      );
                    }
                    return selected === "male"
                      ? "Male"
                      : selected === "female"
                        ? "Female"
                        : "Other";
                  }}
                >
                  <MenuItem value="male" sx={menuItemStyle}>
                    Male
                  </MenuItem>
                  <MenuItem value="female" sx={menuItemStyle}>
                    Female
                  </MenuItem>
                  <MenuItem value="other" sx={menuItemStyle}>
                    Other
                  </MenuItem>
                </Select>
                {errors.gender && (
                  <Typography color="error">{errors.gender}</Typography>
                )}
              </FormControl>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <TableContainer
              sx={{
                mt: 2,
                width: "100%",
                overflowY: "scroll",
                "&::-webkit-scrollbar": {
                  display: "none", // Hide the scrollbar for Webkit browsers (Chrome, Safari)
                },
                "-ms-overflow-style": "none", // Hide scrollbar for IE and Edge
                "scrollbar-width": "none",
              }}
            >
              <Table
                sx={{
                  width: "100%",
                  overflowY: "scroll",
                  "&::-webkit-scrollbar": {
                    display: "none", // Hide the scrollbar for Webkit browsers (Chrome, Safari)
                  },
                  "-ms-overflow-style": "none", // Hide scrollbar for IE and Edge
                  "scrollbar-width": "none", // Hide scrollbar for Firefox
                }}
              >
                <TableHead stickyHeader>
                  <TableRow sx={{ ...drTableGreen, textAlign: "center" }}>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        borderTopLeftRadius: "20px",
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      ID
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        //  paddingX:"4px",
                        textAlign: "center",
                        width: "200px",
                      }}
                    >
                      Name
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        width: "150px",
                        paddingRight: "30px",
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Quantity
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Batch
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Return
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Total Stock
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Pack
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Unit MRP
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      MRP
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Discount
                    </TableCell>
                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      GST
                    </TableCell>

                    <TableCell
                      variant="body1_text_bold"
                      sx={{
                        color: "neutral.black",
                        p: "8px",
                        textAlign: "center",
                      }}
                    >
                      Amount
                    </TableCell>

                    {/* <TableCell
                                            variant="body1_text_bold"
                                            sx={{
                                                color: 'neutral.white',
                                                p: "8px",

                                                textAlign: "center",
                                            }}
                                        >
                                            Edit
                                        </TableCell> */}

                    <TableCell
                      sx={{
                        p: "4px",
                        textAlign: "center",
                        borderTopRightRadius: "20px",
                      }}
                    >
                      <IconButton
                        onClick={handleAddRow}
                        sx={{
                          ...orangeButton,
                          marginLeft: "7px",
                          marginY: "2px",
                        }}
                      >
                        <AddIcon
                          sx={{
                            color: "neutral.white",
                            width: "30px",
                            height: "32px",
                            padding: "0px",
                          }}
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {medicines?.map((medicine, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        ...tableRowLab,
                        // borderBottom: "7px solid white",
                        // borderTop: index === 0 ? "p4x solid white" : " ",
                        // "&:hover": {
                        //   transform: "scale(1.001)",
                        //   // boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        //   // borderRadius: "20px !important",
                        // },
                      }}
                    >
                      <TableCell sx={tableCellLab}>
                        <Typography variant="body_Grey1" color={"text.grey"}>
                          {index + 1}
                        </Typography>
                      </TableCell>

                      <TableCell sx={tableCellLab}>
                        <Autocomplete
                          options={filteredMedicines || []}
                          freeSolo
                          clearOnEscape={false}
                          // clearIcon={null}
                          open={openMedicineList === index}
                          onOpen={() => setOpenMedicines(index)}
                          onClose={() => setOpenMedicines(false)}
                          id={`name-${index}`}
                          inputValue={
                            medicine?.name !== null ? medicine?.name : ""
                          }
                          onInputChange={(e, value) => {
                            handleChange(index, "name", value, e);
                          }}
                          onChange={(e, value) => {
                            // console.log(value);
                            if (!value) {
                              setMedicines((prevMedicines) =>
                                prevMedicines.map((medicine, idx) =>
                                  idx === index
                                    ? {
                                        id: "",
                                        name: "",
                                        quantity: "",
                                        batchId: null,
                                        batch: "",
                                        batchArray: [],
                                        returned: false,
                                        stock: "",
                                        packing: "",
                                        unitMrp: null,
                                        mrp: null,
                                        discount: null,
                                        gst: null,
                                        amount: null,
                                      }
                                    : medicine,
                                ),
                              );
                              setSelectedMedicineForEdit(null);
                              setSelectedMedicine(null);
                            } else if (value && medicine?.id) {
                              handleChange(index, "id", value[0]);
                              handlePresence(index, value);
                              setSelectedMedicine({
                                name: value[1],
                                id: value[0],
                              });
                              setMedicines((prevMedicines) =>
                                prevMedicines?.map((medicine, idx) =>
                                  idx === index
                                    ? {
                                        ...medicine,
                                        quantity: "",
                                        batchId: null,
                                        batch: "",
                                        batchArray: [],
                                        returned: false,
                                        stock: "",
                                        packing: "",
                                        unitMrp: null,
                                        mrp: null,
                                        discount: null,
                                        gst: null,
                                        amount: null,
                                      }
                                    : medicine,
                                ),
                              );
                              setTimeout(() => {
                                document
                                  .getElementById(`quantity-${index}`)
                                  .focus();
                              }, 0);
                            } else {
                              // console.log(value, 'value inside autocomplete ')
                              handleChange(index, "id", value[0]);
                              handlePresence(index, value);
                              setSelectedMedicine({
                                name: value[1],
                                id: value[0],
                              });

                              setTimeout(() => {
                                document
                                  .getElementById(`quantity-${index}`)
                                  .focus();
                              }, 0);
                            }
                          }}
                          sx={textfieldTextBlueBorderPharmacy}
                          PopperComponent={(props) => (
                            <Grid item lg={8}>
                              <Popper
                                {...props}
                                placement="bottom-start"
                                style={menuItemStyle}
                                modifiers={[
                                  {
                                    name: "preventOverflow",
                                    options: {
                                      boundary: "block",
                                    },
                                  },
                                ]}
                              >
                                <div
                                  style={{
                                    maxHeight: 300,
                                    overflowY: "auto",
                                    scrollbarWidth: "none",
                                    maxWidth: "320px",
                                    minWidth: "310px",
                                  }}
                                >
                                  {props.children}
                                </div>
                              </Popper>
                            </Grid>
                          )}
                          getOptionLabel={(option) => option[1]}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              onChange={handleSearch}
                              value={searchTerm}
                              placeholder="Medicine"
                              onKeyDown={(e) => handleKeyDown(e, index, "name")}
                            />
                          )}
                          renderOption={(props, option, { index }) => (
                            <MenuItem
                              sx={{
                                ...menuItemStyle,
                                "&:hover": {
                                  backgroundColor: "#9fd8d8ff !important",
                                  // borderRadius:"20%",
                                  borderRadius: "16px",
                                  color: "black !important",
                                },
                                ...(highlightedIndexMedicine === index && {
                                  backgroundColor: "#9fd8d8ff !important",
                                  color: "black !important",
                                  borderRadius: "16px",
                                }),
                              }}
                              {...props}
                              key={option[0]}
                            >
                              {option[1]}
                            </MenuItem>
                          )}
                        />
                      </TableCell>

                      <TableCell sx={tableCellLab}>
                        <TextField
                          fullWidth
                          placeholder="Quantity"
                          variant="outlined"
                          type="number"
                          value={medicine?.quantity}
                          sx={textfieldTextBlueBorderPharmacy}
                          id={`quantity-${index}`}
                          onKeyDown={(e) => handleKeyDown(e, index, "quantity")}
                          onChange={(e) => {
                            if (e.target.value < 0) {
                              return;
                            }
                            handleChange(index, "quantity", e.target.value);
                            handleQuantityChange(
                              index,
                              "quantity",
                              e.target.value,
                            );
                          }}
                          // error={
                          //     medicine?.quantity ? medicine?.quantity <= 0 : false
                          // }
                          inputProps={{
                            min: 0,
                          }}
                          // helperText={
                          //     medicine?.quantity <= 0 && medicine?.quantity
                          //         ? "Quantity must be more than zero"
                          //         : null
                          // }
                        />
                      </TableCell>

                      <TableCell sx={{ ...tableCellLab, width: "100px" }}>
                        <FormControl fullWidth variant="outlined">
                          <Select
                            sx={{
                              ...textfieldTextBlueBorderPharmacy,
                              backgroundColor: "white",
                              borderRadius: "8px",
                              "& .MuiSelect-select": {
                                padding: "9px", // Custom padding for select dropdown
                              },

                              minWidth: "130px",
                              ...(medicine?.batchError && {
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#ed5564 !important",
                                  borderWidth: "1.5px",
                                },
                                borderColor: "#ed5564 !important",
                              }),
                            }}
                            placeholder="batch"
                            fullWidth
                            value={medicines[index]?.batchId || ""}
                            onChange={(e) => {
                              handleChange(index, "batchId", e.target.value);
                              handleQuantityChange(
                                index,
                                "batchId",
                                e.target.value,
                              );
                            }}
                            renderValue={(selected) => {
                              // Find the selected batch object by ID
                              const selectedBatch = medicines[
                                index
                              ]?.batchArray?.find(
                                (batch) => batch.id === selected,
                              );
                              return selectedBatch?.batch_no || "Select Batch";
                            }}
                          >
                            {medicines[index]?.batchArray?.map((batch) => (
                              <MenuItem key={batch.id} value={batch.id}>
                                {/* {batch.batch_no} */}

                                {/* {`${batch.batch_no} - Exp: ${(batch.expiry_date)} - Qty: ${batch.stock_left}`} */}
                                <Box display="flex" flexDirection="column">
                                  <Typography fontSize="14px" fontWeight={400}>
                                    {batch?.batch_no}
                                  </Typography>

                                  <Typography
                                    fontSize="12px"
                                    color="text.secondary"
                                  >
                                    {`${batch?.stock_left}  |  `}
                                    {expiryMedicineFormate(batch?.expiry_date)}
                                  </Typography>
                                </Box>
                              </MenuItem>
                            ))}
                          </Select>
                          {/* Render the batch stock and expiry date */}
                          {!medicine?.batchId &&
                          medicine?.is_consumable === false ? (
                            <FormHelperText>
                              Please select a batch.
                            </FormHelperText>
                          ) : (
                            ""
                          )}
                          <Box
                            justifyContent={"space-between"}
                            display={"flex"}
                            paddingX={"2px"}
                          >
                            <Typography
                              fontSize={"12px"}
                              color={` ${
                                medicine?.quantity >
                                  medicines[index]?.batch?.stock_left ||
                                isExpiredDate(
                                  medicines[index]?.batch?.expiry_date,
                                )
                                  ? "#ed5564"
                                  :medicine?.batchError ?"#ed5564" : "text.grey"
                              } `}
                            >
                              {medicine?.batchError  ? "0": medicines[index]?.batch?.stock_left}
                            </Typography>

                            <Typography fontSize={"12px"}>
                              {highLightUPcomingMonthsExpire(
                                medicines[index]?.batch?.expiry_date,
                              )}

                              {/* {medicines[index]?.batch?.expiry_date} */}
                            </Typography>
                          </Box>
                        </FormControl>
                      </TableCell>

                      <TableCell sx={tableCellLab}>
                        <Checkbox
                          id={`return-${index}`}
                          onKeyDown={(e) => handleKeyDown(e, index, "return")}
                          onChange={(e) => {
                            handleChange(index, "return", e.target.value);
                            handleReturnChange(index);
                          }}
                          sx={{ height: "10px", width: "10px" }}
                          disabled={!medicine?.id}
                        />
                      </TableCell>

                      <TableCell sx={tableCellLab}>
                        <Typography
                          variant="body_Grey1"
                          color={` ${
                            medicine?.quantity > medicine.stock
                              ? "#ed5564"
                              : "text.grey"
                          } `}
                        >
                          { medicine?.stock}
                        </Typography>
                      </TableCell>

                      <TableCell sx={tableCellLab}>
                        <Typography variant="body_Grey1" color={"text.grey"}>
                          {medicine?.packing}
                        </Typography>
                      </TableCell>

                      <TableCell sx={tableCellLab}>
                        {medicine.returned ? (
                          <Typography variant="body_Grey1" color={"#ed5564"}>
                            {" "}
                            {medicine?.unitMrp}{" "}
                          </Typography>
                        ) : (
                          <Typography variant="body_Grey1" color={"text.grey"}>
                            {medicine?.unitMrp}
                          </Typography>
                        )}
                      </TableCell>

                      <TableCell sx={tableCellLab}>
                        {medicine.returned ? (
                          <Typography variant="body_Grey1" color={"#ed5564"}>
                            {" "}
                            {/* {(medicine?.mrp)}{" "} */}
                            {isNaN(medicine?.mrp) ? "" : medicine?.mrp}{" "}
                          </Typography>
                        ) : (
                          <Typography variant="body_Grey1" color={"text.grey"}>
                            {isNaN(+medicine?.mrp) ? "" : medicine?.mrp}{" "}
                            {/* {(+medicine.mrp)} */}
                          </Typography>
                        )}
                      </TableCell>

                      <TableCell sx={tableCellLab}>
                        {medicine.returned ? (
                          <Typography variant="body_Grey1" color={"#ed5564"}>
                            {" "}
                            {specialDiscountPct
                              ? `${specialDiscountPct}%`
                              : medicine.discount}{" "}
                          </Typography>
                        ) : (
                          <Typography variant="body_Grey1" color={"text.grey"}>
                            {specialDiscountPct
                              ? `${specialDiscountPct}%`
                              : medicine.discount}
                          </Typography>
                        )}
                      </TableCell>

                      <TableCell sx={tableCellLab}>
                        <Typography variant="body_Grey1" color={"text.grey"}>
                          {medicine.gst}
                        </Typography>
                      </TableCell>

                      <TableCell sx={tableCellLab}>
                        {medicine.returned ? (
                          <Typography variant="body_Grey1" color={"#ed5564"}>
                            {" "}
                            {specialDiscountPct
                              ? (
                                  (parseFloat(medicine?.unitMrp) || 0) *
                                  (parseFloat(medicine?.quantity) || 0) *
                                  (1 - parseFloat(specialDiscountPct) / 100)
                                ).toFixed(2)
                              : medicine?.amount}{" "}
                          </Typography>
                        ) : (
                          <Typography variant="body_Grey1" color={"text.grey"}>
                            {specialDiscountPct
                              ? (
                                  (parseFloat(medicine?.unitMrp) || 0) *
                                  (parseFloat(medicine?.quantity) || 0) *
                                  (1 - parseFloat(specialDiscountPct) / 100)
                                ).toFixed(2)
                              : medicine?.amount}
                          </Typography>
                        )}
                      </TableCell>

                      {/* <TableCell sx={tableCellLab}>
                                                {medicine?.id && <IconButton
                                                    // sx={{ marginLeft: '8px', marginBottom: "7px", }}
                                                    onClick={() => {
                                                        setSelectedMedicineForEdit(medicine?.id);
                                                        setEditMedicine(true);
                                                    }}
                                                >
                                                    <Edit sx={{
                                                        ...xBtn, width: '26px', height: '26px', borderRadius: '20%', backgroundColor: '#268bd4',
                                                        "&:hover": {
                                                            backgroundColor: "#268bd4",
                                                        },
                                                    }} />
                                                </IconButton>
                                                }
                                            </TableCell> */}

                      <TableCell sx={tableCellLab}>
                        <IconButton
                          sx={{ marginLeft: "8px", marginBottom: "7px" }}
                          onClick={() => handleRemoveRow(index)}
                        >
                          <CloseIcon
                            sx={{ ...xBtn, width: "26px", height: "26px" }}
                          />
                        </IconButton>

                        {medicine?.id && (
                          <IconButton
                            // sx={{ marginLeft: '8px', marginBottom: "7px", }}
                            onClick={() => {
                              setSelectedMedicineForEdit(medicine?.id);
                              setEditMedicine(true);
                            }}
                          >
                            <Edit
                              sx={{
                                ...xBtn,
                                width: "23px",
                                height: "23px",
                                borderRadius: "50%",
                                p: 0.4,
                                color: "neutral.white",
                                // border: '2px solid #007A99',
                                backgroundColor: "neutral.teal",
                                "&:hover": {
                                  backgroundColor: "neutral.teal",
                                },
                                marginBottom: "7px",
                              }}
                            />
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* <Box
              sx={{
                ...tableRowLab,
                "&:hover": {
                  transform: "scale(1.001)",
                  // boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  // borderRadius: "20px !important",
                },
                borderBottomLeftRadius: "20px",
                borderBottomRightRadius: "20px",
                borderTopLeftRadius: "0px",
                borderTopRightRadius: "0px",
                justifyContent: "space-between",
                display: "flex",
                height: "60px",
                alignItems: "center",
                padding: "3px",
                paddingX: "40px",
              }}
            >
              <Box
                sx={{
                  justifyContent: "space-between",
                  display: "flex",
                  height: "60px",
                  alignItems: "center",
                }}
                columnGap={"10px"}
              >
                <Typography variant="h6" fontSize={"19px"}>
                  Selected :{" "}
                </Typography>
                <Typography variant="h6" fontSize={"19px"}>
                  {select}
                </Typography>
              </Box>
            

              <Box
                sx={{
                  justifyContent: "space-between",
                  display: "flex",
                  height: "60px",
                  alignItems: "center",
                }}
                columnGap={"10px"}
              >
                <Typography variant="h6" fontSize={"20px"}>
                  Total:
                </Typography>

                <Typography variant="h6" fontSize={"20px"}>
                  {isNaN(total) ? 0 : total?.toFixed(2)}
                </Typography>
              </Box>
            </Box> */}
          </Grid>
        </Box>

        {/* Payment + Save*/}
        <Paper
          elevation={6}
          sx={{
            position: "sticky",
            bottom: 0,
            zIndex: 20,
            mt: 1,
            minHeight: "max-content",
            borderRadius: "16px",
            overflow: "hidden",
            border: "1px solid rgba(0,0,0,0.08)",
            backdropFilter: "blur(6px)",
          }}
        >
          {/* Top row */}
          <Box
            sx={{
              px: 2,
              py: 1.5,
              background:
                "linear-gradient(180deg, rgba(0,103,255,0.06), rgba(0,0,0,0))",
            }}
          >
            <Stack
              spacing={2}
              alignItems={{ xs: "start" }}
              justifyContent="space-between"
              direction={"column"}
            >
              <Stack
                direction="row"
                // spacing={2}
                gap={2}
                alignItems="center"
                flexWrap="wrap"
                sx={{ flex: 1 }}
              >
                {/* Row 1 */}
                <FormControl sx={{ minWidth: 200 }} variant="outlined">
                  <InputLabel shrink id="payment-mode-label-0">
                    Payment Mode
                  </InputLabel>
                  <Select
                    labelId="payment-mode-label-0"
                    label="Payment Mode"
                    value={
                      invoicePaymentsAttributes?.[0]?.payment_mode || "Cash"
                    }
                    onChange={(e) =>
                      updatePaymentRow(0, "payment_mode", e.target.value)
                    }
                    sx={{
                      ...selectField,
                      height: 44,
                      backgroundColor: "white",
                    }}
                  >
                    {getAvailablePaymentModes(0).map((m) => (
                      <MenuItem
                        key={m.value}
                        value={m.value}
                        sx={menuItemStyle}
                      >
                        {m.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <TextField
                  InputLabelProps={{ shrink: true }}
                  label="Net Payable"
                  type="text"
                  inputProps={{ inputMode: "decimal" }}
                  value={invoicePaymentsAttributes?.[0]?.amount ?? ""}
                  onChange={(e) => handlePrimaryAmountChange(e.target.value)}
                  onBlur={handlePrimaryAmountBlur}
                  shrink={true}
                  sx={{
                    ...textfieldTextPrep,
                    width: 220,
                    "& .MuiInputBase-root": {
                      height: 44,
                      backgroundColor: "white",
                    },
                  }}
                />

                <TextField
                  InputLabelProps={{ shrink: true }}
                  label="Special Discount %"
                  type="number"
                  value={specialDiscountPct}
                  onChange={(e) => handleSpecialDiscountPct(e.target.value)}
                  inputProps={{ min: 0, max: 100, step: 0.01 }}
                  sx={{
                    ...textfieldTextPrep,
                    width: 180,
                    "& .MuiInputBase-root": {
                      height: 44,
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  InputLabelProps={{ shrink: true }}
                  label="Special Discount ₹"
                  type="number"
                  value={specialDiscountINR}
                  onChange={(e) => handleSpecialDiscountINR(e.target.value)}
                  inputProps={{ min: 0, step: 0.01 }}
                  sx={{
                    ...textfieldTextPrep,
                    width: 180,
                    "& .MuiInputBase-root": {
                      height: 44,
                      backgroundColor: "white",
                    },
                  }}
                />

                {/* Row 2 appears automatically */}
                {invoicePaymentsAttributes.length === 2 && (
                  <>
                    <FormControl sx={{ minWidth: 200 }} variant="outlined">
                      <InputLabel shrink id="payment-mode-label-1">
                        Payment Mode 2
                      </InputLabel>
                      <Select
                        labelId="payment-mode-label-1"
                        label="Mode 2"
                        value={
                          invoicePaymentsAttributes?.[1]?.payment_mode || "UPI"
                        }
                        onChange={(e) =>
                          updatePaymentRow(1, "payment_mode", e.target.value)
                        }
                        sx={{
                          ...selectField,
                          height: 44,
                          backgroundColor: "white",
                        }}
                      >
                        {getAvailablePaymentModes(1).map((m) => (
                          <MenuItem
                            key={m.value}
                            value={m.value}
                            sx={menuItemStyle}
                          >
                            {m.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <TextField
                      label="Remaining"
                      value={invoicePaymentsAttributes?.[1]?.amount ?? ""}
                      inputProps={{ readOnly: true }}
                      sx={{
                        ...textfieldTextPrep,
                        width: 220,
                        "& .MuiInputBase-root": {
                          height: 44,
                          backgroundColor: "#f7f7f7",
                        },
                      }}
                    />
                  </>
                )}
              </Stack>

              {/* Summary */}
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent={{ xs: "flex-start", md: "flex-end" }}
                flexWrap="wrap"
              >
                <Chip
                  label={
                    <Typography fontWeight={800}>
                      Taxable Amt:{" "}
                      {Number(billSummary.taxableTotal || 0).toFixed(2)}
                    </Typography>
                  }
                />
                <Chip
                  label={
                    <Typography fontWeight={800}>
                      GST: {Number(billSummary.totalGst || 0).toFixed(2)}
                    </Typography>
                  }
                />
                <Chip
                  label={
                    <Typography fontWeight={800}>
                      Discount: {Number(billSummary.discount || 0).toFixed(2)}
                    </Typography>
                  }
                />
                {roundOff !== null && roundOff !== undefined && (
                  <Chip
                    label={
                      <Typography fontWeight={800}>
                        Round Off: {roundOff}
                      </Typography>
                    }
                  />
                )}
                <Chip
                  sx={{ backgroundColor: "#e8f5e9" }}
                  label={
                    <Typography fontWeight={800} color="green">
                      Net Payable:{" "}
                      {Number(billSummary.netPayable || 0).toFixed(2)}
                    </Typography>
                  }
                />
                {/* <Chip
                                  label={
                                    <Typography fontWeight={800}>
                                      Paid: {paidTotal.toFixed(2)}
                                    </Typography>
                                  }
                                />
                                <Chip
                                  variant="outlined"
                                  sx={{
                                    borderColor:
                                      Number(remainingTotal) === 0
                                        ? "rgba(0,0,0,0.12)"
                                        : "rgba(237, 85, 100, 0.6)",
                                  }}
                                  label={
                                    <Typography fontWeight={800}>
                                      Remaining: {remainingTotal}
                                    </Typography>
                                  }
                                /> */}
              </Stack>
            </Stack>

            {errors.split_payment && (
              <Typography color="error" fontSize="12px" mt={1}>
                {errors.split_payment}
              </Typography>
            )}
          </Box>

          <Divider />
          <Box
            sx={{
              px: 2,
              py: 1.5,
              display: "flex",
              justifyContent: "flex-end",
              gap: 1,
              backgroundColor: "rgba(0,0,0,0.015)",
            }}
          >
            {" "}
            <Button
              onClick={() => saveAndPrint()}
              className="btn draw-border"
              variant="contained"
              id="submit"
              sx={{
                ...primaryBtnTeal,
                width: "195px",
                // display: showButton ? "flex" : "none",
                alignItems: "center",
                justifyContent: "center",
              }}
              disabled={
                isLoading ||
                isButtonDisable ||
                isPriceFetching ||
                (allowBatchStockZero &&
                  medicines.some((m) => m?.batchError))
              }
            >
              <Typography
                textTransform={"capitalize"}
                color={"neutral.white"}
                variant="title1_medium"
              >
                Save and Print
              </Typography>
            </Button>
          </Box>
        </Paper>
      </Box>
      <div style={{ display: "none" }}>
        <PharmacyInvoice props={printInvoiceData} ref={printRef} />
      </div>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%", maxWidth: "90%" }}
        open={editMedicine}
        onClose={() => setEditMedicine(false)}
      >
        <EditMedicineBatchShort
          onClose={() => setEditMedicine(false)}
          id={selectedMedicineForEdit}
        />
      </CustomModal>

      <Dialog
        open={showPastBillConfirm}
        onClose={() => setShowPastBillConfirm(false)}
      >
        <DialogTitle>Create Past-Dated Bill?</DialogTitle>
        <DialogContent>
          <Typography>
            You are creating a bill for a past date (
            <strong>{dayjs(generatedAt).format("DD MMM YYYY, h:mm A")}</strong>
            ). Do you want to continue?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowPastBillConfirm(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={() => {
              setShowPastBillConfirm(false);
              saveAndPrint(true);
            }}
            sx={{ backgroundColor: "#0097B2" }}
          >
            Yes, Create Bill
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NewBill;
